var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toaster',{attrs:{"has-undo":""},on:{"undo-action":_vm.undoAction,"close-toaster":_vm.closeToaster},scopedSlots:_vm._u([{key:"text",fn:function(){return [_vm._v("\n    ההודעה לא תוצג יותר\n  ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }